<template>
    <div>

      <loading v-show="showLoading"></loading>

      <div class="home_content" v-show="!showLoading">
        <!--首页搜索-->
        <div class="nav_bar">
<!--          <button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>-->
          <div class="clear_style fl nav_bar_search" @click="popSearchView()">
            <img  src="@/images/icon_search.png">
            <span>{{keyWord == undefined? "请输入要搜索的宝贝":keyWord}}</span>
          </div>
          <button class="clear_style fl nav_bar_right_item" style="width: 2rem;height: 2rem" @click="changeLayout"><img class="nav_item_btn" :src="layout==true?list1_icon:list2_icon"></button>

          <!--searchBar-->
          <div class="search_bar clear_both" style="z-index: 101;background-color: white">
            <div class="fl" style="background-color: white;color: #9E9E9E" ref="search0" role="button" index="0" :status="search0_status" @click="changeSearchBarStyle(0,search0_status)">
              <span>综合</span>
            </div>
            <div class="fl" style="background-color: white;color: #9E9E9E" ref="search1" role="button" index="1" :status="search1_status" @click="changeSearchBarStyle(1,search1_status)"><span>销量</span></div>
            <div class="fl" style="background-color: white;color: #9E9E9E" ref="search2" role="button" index="2" :status="search2_status" @click="changeSearchBarStyle(2,search2_status)">
              <span>价格</span>
              <img ref="jiage" class="search_bar_icon" src="@/images/icon_jiage@3x.png">
            </div>
            <div class="fl" style="background-color: white;color: #9E9E9E" ref="search3" role="button" index="3" :status="search3_status" @click="changeSearchBarStyle(3,search3_status)">
              <span>筛选</span>
              <img class="search_bar_icon" src="@/images/icon_shaixuan@3x.png">
            </div>
          </div>
        </div>

        <!--searchAction-->
        <div>
          <!--marksView-->
          <div class="markView" ref="overMarkView" @click="closeAll()"></div>
          <!--综合排序-->
          <div ref="sortMultiple" class="animate_action sortMultiple full_w">
            <div role="button" class="sortMultiple_cell">全部商品</div>
            <div role="button" class="sortMultiple_cell">新款商品</div>
            <div role="button" class="sortMultiple_cell">活动商品</div>
          </div>
          <!--筛选的内容-->
          <div ref="sortScreen" class="animate_action sortScreen">
            <div class="scorll_content element">

              <div role="cell" class="sortMultiple_cell">
                <p class="cell_title"><span class="fl">服务</span></p>
                <ul>
                  <li @click="refreshData(0,0,chargeShipping)" :class="{'active':chargeShipping=='Y'}"><span>包邮</span></li>
                  <li @click="refreshData(1,0,inStock)" :class="{'active':inStock=='Y'}"><span>仅看有货</span></li>
                </ul>
              </div>

              <div role="cell" class="sortMultiple_cell">
                <p class="cell_title"><span class="fl">价格</span></p>
                <ul>
                  <input type="number" oninput="value=value.replace(/[^\d]/g,'')" v-model="priceLow" ref="priceLow"  class="tc input_view" placeholder="最低价"> —
                  <input type="number" oninput="value=value.replace(/[^\d]/g,'')" v-model="priceHigh" ref="priceHigh" class="tc input_view" placeholder="最高价">
                </ul>
              </div>
              <div role="cell" v-show="productCategoryList.length > 0" class="sortMultiple_cell">
                <p class="cell_title"><span class="fl">分类</span><span class="fr" @click="openScreenView($event)"><img class="open_btn" src="@/images/icon_arrow_Put away@3x.png"></span></p>
                <ul class="close_ul">
                  <li @click="refreshData(productCategoryItem.productCategoryId,2,productCategoryItem.isSelect)" :class="{'active':productCategoryItem.isSelect=='Y'}" v-for="(productCategoryItem, index) in productCategoryList" @key="index"><span>{{productCategoryItem.productCategoryName}}</span></li>
                </ul>
              </div>
              <div role="cell" v-show="brandList.length > 0" class="sortMultiple_cell">
                <p class="cell_title"><span class="fl">品牌</span><span class="fr" @click="openScreenView($event)"><img class="open_btn" src="@/images/icon_arrow_Put away@3x.png"></span></p>
                <ul class="close_ul">
                  <li @click="refreshData(brandItem.brandId,3,brandItem.isSelect)" :class="{'active':brandItem.isSelect=='Y'}" v-for="(brandItem, index) in brandList" @key="index"><span>{{brandItem.brandName}}</span></li>
                </ul>
              </div>
              <div role="cell" v-show="productFeatureTypeList.length > 0" v-for="(productFeatureItem, featureIndex) in productFeatureTypeList" @key="featureIndex" class="sortMultiple_cell">
                <p class="cell_title"><span class="fl">{{productFeatureItem.productFeatureTypeName}}</span><span @click="openScreenView($event)" class="fr"><img class="open_btn" src="@/images/icon_arrow_Put away@3x.png"></span></p>
                <ul class="close_ul">
                  <li @click="refreshData(childProductFeatureItem.productFeatureId,4+featureIndex,childProductFeatureItem.isSelect)" :class="{'active':childProductFeatureItem.isSelect=='Y'}" v-for="(childProductFeatureItem,productFeatureItemIndex) in productFeatureItem.productFeatureList" @key="productFeatureItemIndex"><span>{{childProductFeatureItem.productFeatureName}}</span></li>
                </ul>
              </div>
            </div>
            <div role="cell" class="sortMultiple_cell" style="padding-left: 3.2rem">
              <div role="button" @click="clearSetting()" class="fl tc reset_btn" >重置</div>
              <div role="button" @click="searchAction()" class="fl tc done_btn" >确定({{listSize<99?listSize:'99+'}})</div>
            </div>
          </div>
        </div>
        <!--productList-->
        <div class="pl_content clear_both">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div id="content" ref="content" @scroll="scrollEvent()">
              <div v-for="(productItem,index) in productList" :key="index" :class="[layout==true?'pl_info1 fl':'pl_info2']">
                <div @click="pushDetailView(productItem)">
                  <van-image :class="[layout==true?'pl_info1_img':'pl_info2_img']" fit="cover" :src="productItem.imgSrc"/>
                  <p :class="[layout==true?'pl_info1_title':'pl_info2_title']">{{productItem.productName}}</p>
                  <span  :class="[layout==true?'pl_info1_price fl':'pl_info2_price fl']">¥{{productItem.price.toFixed(2)}}</span>
                  <span :class="[layout==true?'pl_info1_addCart fr':'pl_info2_addCart fr']">{{productItem.quantity}}人付款</span>
                </div>
              </div>
              <div class="cart_content" v-if="emptyList">
                <p class="tc grey zt14" style="padding: 2rem 0">暂无可售商品信息</p>
              </div>
              <refresh class="fl full_w" style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: productList.length,show:show}'></refresh>
            </div>
          </van-pull-refresh>
        </div>
      </div>

      <div class="home_search" v-show="isShowSearch" style="width: 100%;height: 100%;position: fixed;top: 0;background-color: white;z-index: 101;">
        <form action="/">
          <van-search
            class="search_br"
            shape="round"
            placeholder="hello kitty 公仔"
            v-model="searchValue"
            show-action
            @search="searchAction1()"
            @cancel="dismissSearchView"
          />
        </form>
        <div class="content_container" >
          <p class="zt12">热门搜索</p>
          <ul class="tag_list">
            <li class="fl" v-for="(tagItem, index) in tagList" :key="index"><span @click="refreshOnView(tagItem)" class="tag_item zt12">{{tagItem.keyword}}</span></li>
          </ul>
        </div>
      </div>

      <transition name="router-slid" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getProductCategory,getKeyword,searchProduct,login } from '@/router/api';
  import { NavBar,Image,Tabbar,DropdownMenu,DropdownItem,SwitchCell,Button } from 'vant';
  import { Search,Overlay,List,PullRefresh,Toast } from 'vant';
  import { setStore,getStore,getCookie,setCookie,GetQueryString } from '@/utils/mUtil';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  var isFromGoodsDetail = false

  export default {
    name: 'productList',

    components: {
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Tabbar.name]: Tabbar,
      [Search.name]: Search,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      [SwitchCell.name]: SwitchCell,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [List.name]: List,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh
    },

    data() {
      return {
        searchValue:"",
        isLoading:false,
        showLoading:true,
        activeIndex: 0,
        isShowSearch:false, //是否显示搜索页
        search0_status: 0,  //点击第1个筛选项的状态
        search1_status: 0,  //点击第2个筛选项的状态
        search2_status: 0,  //点击第3个筛选项的状态
        search3_status: 0,  //点击第4个筛选项的状态
        list1_icon:require('@/images/icon_columnlist@3x.png'),    //大图模式图标
        list2_icon:require('@/images/icon_rowlist@3x.png'),    //列表模式图标
        layout:'',        //切换模式
        tagList:[],
        productList:[],
        brandList:[],
        productCategoryList:[],
        productFeatureTypeList:[],
        listSize:0,
        sortMultiple:["综合排序1","综合排序2","综合排序3"],
        keyWord:this.$route.query.keyWord,
        token:getStore('externalLoginKey'),
        productCategoryId:this.$route.query.productCategoryId,
        viewIndex:this.$route.query.viewIndex==undefined?20:this.$route.query.viewIndex,  //default 0
        viewSize:this.$route.query.viewSize==undefined?20:this.$route.query.viewSize,
        orderBy:"",
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        inStock:this.$route.query.inStock,
        chargeShipping:this.$route.query.chargeShipping,
        priceLow:this.$route.query.priceLow,
        priceHigh:this.$route.query.priceHigh,
        brandId:this.$route.query.brandId,
        featureIds:this.$route.query.featureIds==undefined?'':this.$route.query.featureIds,
        emptyList:false,

        show: false,
        allLoaded: false,
      }
    },

    methods: {
      async initData() {
        // 谁能想到localstorage里面存储的内容是string
        this.layout = getStore('layout')
        if (getStore('layout') == 'true'){
          this.layout = true
        } else if (getStore('layout') == 'false') {
          this.layout = false
        } else {
          // 如果刚进来无值就默认是大图模式
          this.layout = true
        }
        console.log(this.layout)

        this.searchProduct();
        this.getKeyword();
      },
      searchProduct() {
        /**
         * parameters:
         * {
         *    keyWord
         *    token
         *    productCategoryId
         *    viewIndex
         *    viewSize
         *    orderBy
         *    productStoreId
         *    prodCatalogId
         *    inStock
         *    chargeShipping
         *    priceLow
         *    priceHigh
         *    brandId
         *    featureIds
         * }
         */
        // 进来默认排序为综合排序
        if (this.orderBy == '') {
          this.$refs.search0.style.color = "#666666";
          this.search0_status = 1;
          this.orderBy = "synthesizeAdd";
        }
        this.token = getStore('externalLoginKey')
        // 初始化viewIndex
        this.viewIndex = 0
        var param = {keyWord:this.keyWord,externalLoginKey:this.token,productCategoryId:this.productCategoryId,viewIndex:this.viewIndex,viewSize:this.viewSize,orderBy:this.orderBy,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId,featureIds:this.featureIds,brandId:this.brandId,priceLow:this.priceLow,priceHigh:this.priceHigh,chargeShipping:this.chargeShipping,inStock:this.inStock}
        console.log('param=============')
        console.log(param)
        searchProduct({keyWord:this.keyWord,externalLoginKey:this.token,productCategoryId:this.productCategoryId,viewIndex:this.viewIndex,viewSize:this.viewSize,orderBy:this.orderBy,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId,featureIds:this.featureIds,brandId:this.brandId,priceLow:this.priceLow,priceHigh:this.priceHigh,chargeShipping:this.chargeShipping,inStock:this.inStock})
          .then(res => {
            console.log(res);
            console.log("searchProduct")
            if (res.productList) {
              if (res.productList.length == 0){
                this.emptyList = true
              } else {
                this.emptyList = false
              }
              this.productList = res.productList;
              this.brandList = res.brandList;
              this.productCategoryList = res.productCategoryList;
              this.productFeatureTypeList = res.productFeatureTypeList;
              this.viewIndex = res.viewIndex;
              this.viewSize = res.viewSize;
              this.listSize = res.listSize;
              if (res.listSize == 0){
                // Toast('未搜索到您想要的宝贝')
              }
              this.inStock = res.inStock;
              this.chargeShipping = res.chargeShipping;
              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
              if (this.productList.length < res.listSize) {
                this.allLoaded = false
                this.show = true
              }
              console.log(this.allLoaded,this.productList.length,this.show)
              this.$router.replace({path:'/productList',query:{keyWord:this.keyWord,externalLoginKey:this.token,productCategoryId:this.productCategoryId,viewIndex:this.viewIndex,viewSize:this.viewSize,orderBy:this.orderBy,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId,featureIds:this.featureIds,brandId:this.brandId,priceLow:this.priceLow,priceHigh:this.priceHigh,chargeShipping:this.chargeShipping,inStock:this.inStock}})
            } else {
              // Toast("未搜索到您想要的宝贝");
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getKeyword() {
        getKeyword({token:"",productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
          .then(res => {
            this.tagList = res.kryWordList
          })
          .catch(err => {
            console.log(err);
          });
      },
      // 弹出搜索框
      popSearchView: function () {
        this.isShowSearch = true;
        document.querySelector('body').setAttribute('style', 'overflow:hidden');
      },
      // 隐藏框搜索框
      dismissSearchView: function () {
        this.isShowSearch = false;
        document.querySelector('body').removeAttribute('style');
      },
      //切换搜索状态
      //当前状态只用于展示哪个按钮被点击
      changeSearchBarStyle (index,status) {
        this.clearStyle();
        this.closeAll();
        switch (index) {
          case 0:
            if (status == 0) {
              this.$refs.search0.style.color = "#666666";
              this.search0_status = 1;
              this.orderBy = "synthesizeAdd";
              this.searchProduct();
            } else if (status == 1) {
              this.$refs.search0.style.color = "#999999";
              this.search1_status = 0;
              this.orderBy = "";
              this.searchProduct();
            }
            break;
          case 1:
            if (status == 0) {
              this.$refs.search1.style.color = "#666666";
              this.search1_status = 1;
              this.orderBy = "salesReduce";
              this.searchProduct();
            } else if (status == 1) {
              this.$refs.search1.style.color = "#999999";
              this.search1_status = 0;
              this.orderBy = "";
              this.searchProduct();
            }
            break;
          case 2:
            if (status == 0) {
              this.$refs.search2.style.color = "#666666";
              this.$refs.jiage.src = require('@/images/icon_jiage_up@3x.png');
              this.search2_status = 1;
              this.orderBy = "priceAdd";
              this.searchProduct();
            } else if (status == 1) {
              this.$refs.search2.style.color = "#666666";
              this.$refs.jiage.src = require('@/images/icon_jiage_down@3x.png');
              this.search2_status = 2;
              this.orderBy = "priceReduce";
              this.searchProduct();
            } else if (status == 2) {
              this.$refs.search2.style.color = "#666666";
              this.$refs.jiage.src = require('@/images/icon_jiage_up@3x.png');
              this.search2_status = 1;
              this.orderBy = "priceAdd";
              this.searchProduct();
            }
            break;
          case 3:
            if (status == 0) {
              this.$refs.search3.style.color = "#666666";
              this.search3_status = 1;
              this.openSortScreen();
            } else if (status == 1) {
              this.$refs.search3.style.color = "#999999";
              this.search3_status = 0;
              this.closeSortScreen();
            }
            break;
          default:
            break;
        }
      },
      // 清楚搜索样式
      clearStyle () {
        this.search0_status = 0;
        this.$refs.search0.style.color = "#999999";
        this.search1_status = 0;
        this.$refs.search1.style.color = "#999999";
        this.search2_status = 0;
        this.$refs.search2.style.color = "#999999";
        this.search3_status = 0;
        this.$refs.search3.style.color = "#999999";
        this.$refs.jiage.src = require('@/images/icon_jiage@3x.png');
      },
      // 切换列表还是大图
      changeLayout () {
        this.layout = !this.layout
        setStore('layout',this.layout)
        console.log(this.layout)
      },
      // 弹出综合排序
      openSortMultiple () {
        this.$refs.sortMultiple.style.top = "5.5rem";
        this.$refs.overMarkView.style.display = "block";
      },
      // 收起综合排序
      closeSortMultiple () {
        this.$refs.sortMultiple.style.top = "-25rem";
        this.$refs.overMarkView.style.display = "none";
      },
      //弹出筛选
      openSortScreen () {
        this.$refs.sortScreen.style.top = "5.5rem";
        this.$refs.overMarkView.style.display = "block";
      },
      //收起筛选
      closeSortScreen () {
        this.$refs.sortScreen.style.top = "-25rem";
        this.$refs.overMarkView.style.display = "none";
      },
      //收起all
      closeAll () {
        this.closeSortMultiple();
        this.closeSortScreen();
        this.clearStyle();
      },
      // 点击选中刷新数据
      refreshData (param,index,isSelected) {
        if (index == 0) { // 服务
          if (param == 0) {
            if (isSelected == "N") {
              this.chargeShipping = "Y"
              this.searchProduct();
            } else {
              this.chargeShipping = ""
              this.searchProduct();
            }
          } else if (param == 1) {
            if (isSelected == "N") {
              this.inStock = "Y"
              this.searchProduct();
            } else {
              this.inStock = ""
              this.searchProduct();
            }
          }
        } else if (index == 1) {  // 价格忽略不计

        } else if (index == 2) {  // 分类
          if (isSelected == "N") {
            this.productCategoryId = param
            this.searchProduct();
          } else {
            this.productCategoryId = ""
            this.searchProduct();
          }
        } else if (index == 3) {  // 品牌
          if (isSelected == "N") {
            this.brandId = param
            this.searchProduct();
          } else {
            this.brandId = ""
            this.searchProduct();
          }
        } else if (index >= 4) {  // 特征
          if (isSelected == "N") {
            if (this.featureIds == ""||this.featureIds == undefined) {
              this.featureIds += param
              this.searchProduct();
            } else {
              this.featureIds += "," + param
              this.searchProduct();
            }
          } else {
            if (this.featureIds.indexOf('-'+param) != -1) {
              this.featureIds = this.featureIds.replace('-'+param,"")
            };
            if (this.featureIds.indexOf(param) != -1) {
              this.featureIds = this.featureIds.replace(param,"")
            };
            this.searchProduct();
          }
        }
      },
      //展开筛选条件
      openScreenView (e){
        // 操作dom不是个好事情，要少做
        var targetItem = e.currentTarget.parentElement.nextElementSibling;
        if (targetItem.style.height=="0px" || targetItem.style.height=="" ) {
          targetItem.style.height = "auto"
          e.target.src = require('@/images/icon_arrow_drop down@3x.png');
        } else {
          targetItem.style.height = "0px"
          e.target.src = require('@/images/icon_arrow_Put away@3x.png');
        }
      },
      //重置
      clearSetting(){
        this.keyWord = ""
        // this.productCategoryId = ""    // 分类信息不需要重置
        this.viewIndex = 0
        this.viewSize = 2
        this.orderBy = ""
        this.inStock = ""
        this.chargeShipping = ""
        this.priceLow = ""
        this.priceHigh = ""
        this.brandId = ""
        this.featureIds = ""
        this.searchProduct();
      },
      //确定
      searchAction(){
        // 初始化列表的位置
        this.viewIndex = 0
        document.documentElement.scrollTop = 0
        this.searchProduct();
        this.closeSortScreen();
      },
      searchAction1(){
        this.$router.push({path:'/productList',query:{keyWord:this.searchValue}})
        this.onRefresh();
      },
      //本页面选择刷新
      refreshOnView(item) {
        this.$router.push({path:'/productList', query:{keyWord:item.keyword}});
        this.onRefresh();
      },
      //跳转详情页
      pushDetailView (item){
        setStore('productListScrollY',this.$refs.content.scrollTop)
        this.$router.push({name:'goodsDetail',query:{goodsId:item.productId}});
      },
      //下拉刷新
      onRefresh() {
        // if (this.allLoaded != true) {
        setStore('onRefresh',"onRefresh")
          setTimeout(() => {
            window.location.href = window.location.href + "&externalLoginKey="+getStore('externalLoginKey')
            window.location.reload()
          }, 1000);
        // }
      },
      //上拉加载
      loadMore() {
        debugger
        if (!this.allLoaded) {
          this.viewIndex ++;
          searchProduct({keyWord:this.keyWord,token:this.token,productCategoryId:this.productCategoryId,viewIndex:this.viewIndex,viewSize:this.viewSize,orderBy:this.orderBy,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId,featureIds:this.featureIds,brandId:this.brandId,priceLow:this.priceLow,priceHigh:this.priceHigh,chargeShipping:this.chargeShipping,inStock:this.inStock})
            .then(res => {
              if (res.productList) {
                this.show = true
                if (res.productList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }
                var oldProductList = this.productList
                var newProductList = oldProductList.concat(res.productList)
                this.productList = newProductList
                this.viewIndex = res.viewIndex;
              } else {
                // Toast("未搜索到您想要的宝贝");
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },
      scrollEvent() {
        console.log('scrollEvent===');
      }
      // handleScroll:function (e) {
      //   let scrollY = document.documentElement.scrollTop
      //   console.log('scrollY' + scrollY)
      // },
    },
    mounted() {
      this.initData()
      // window.addEventListener('scroll',this.handleScroll,true)
    },
    // //页面离开时销毁监听事件
    // destroyed(){
    //   window.removeEventListener('scroll', this.handleScroll);
    // },
    beforeRouteLeave (to, from, next) {
      if (to.path === '/goodsDetail') {
        from.meta.keepAlive = true
        setStore('productListScrollY',document.documentElement.scrollTop)
      } else {
        from.meta.keepAlive = false
        // this.$destroy()
      }
      next()
    },
    beforeRouteEnter(to, from, next) {

      if (from.name != 'goodsDetail') {
        isFromGoodsDetail = false;
      } else {
        isFromGoodsDetail = true;
      }

      next();
    },
    activated() {
      console.log("看到我就说明我被缓存了");
      if (isFromGoodsDetail) {
        console.log(getStore('productListScrollY'))
        console.log(this.showLoading)
        setTimeout(() => {
          document.documentElement.scrollTop = getStore('productListScrollY')
        }, 500);
      } else {
        this.$refs.content.scrollTop = 0
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .content_container {
    padding: 0 1rem
  }

  .search_bar {

  }

  .search_bar div {
    text-align: center;
    font-size: 0.875rem;
    color: #999999;
    width: 5.8rem;
    line-height: 3rem;
  }

  .search_bar_icon {
    position: absolute;
    width: 1.125rem;height: 1.125rem;
    margin: 0.9rem 0 0 0.2rem;
  }

  .pl_content {
    padding-bottom: 0rem;
    padding-top: 5.4rem;
  }

  .pl_title {
    padding-left: 1rem;font-weight: bold;border-left-width: 0.1rem;border-left-style: solid;border-left-color: #EB84AB
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.875rem;color: #333333;margin-bottom: 0.5rem;height: 2.2rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #9E9E9E;
  }

  .pl_info2 {
    height: 5rem;padding: 0.8rem 1rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info2_img {
    width: 5rem;height: 5rem;float: left;margin-right: 0.5rem;line-height: 6.875rem;
  }

  .pl_info2_title {
    float: left;width: 15rem;height:3rem;margin: 0;font-size: 0.875rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info2_price {
    font-size: 1rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info2_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .tag_list > li {
    line-height: 2rem;
    margin: 0 0.6rem 0.6rem 0;
  }

  .tag_item {
    background-color: #f5f5f5;padding: 0.5rem 1rem;border-radius: 0.3rem;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 19rem;margin: 0 0.4rem;background-color: #f5f5f5;height: 2rem;line-height: 2rem;padding: 0 0.8rem;border-radius: 1rem
  }

  .nav_bar_search > img {
    width: 0.8rem;height: 0.8rem;margin-right: 0.5rem;
  }

  .nav_bar_search > span {
    font-size: 0.75rem;color: #999999;
  }

  .nav_bar_right_item {
    padding-top: 0.3rem;
  }

  .animate_action {
    transition: all .4s;
  }

  .markView {
    display: none;position: fixed;padding-top: 5.5rem;top: 0;left: 0;width: 100%;height: 100%;background-color: #333333;position: fixed;width: 100%;opacity: 0.6;z-index: 99;
  }

  .sortMultiple {
    background-color: white;position: fixed;top: -25rem;left: 0;height: auto;padding: 0.5rem 1rem;
  }

  .sortScreen {
    background-color: white;position: fixed;top: -25rem;left: 0;height: 25rem;overflow: scroll;padding: 0.5rem 1rem;padding-bottom: 1rem;z-index: 100;
  }

  .sortMultiple .sortMultiple_cell:last-child {
    border-style: none;
  }

  .sortScreen .sortMultiple_cell:last-child {
    border-style: none;
  }

  .sortScreen .scorll_content {
    height: 23rem;overflow: hidden;overflow: scroll;
  }

  .sortMultiple_cell {
    padding: 0.4rem 0;
    font-size: 0.875rem;
    color: #999999;
    border-bottom: 1px solid #eaeaea;
  }

  .sortMultiple_cell > p {
    margin: 0.5rem 0;
  }

  .sortMultiple_cell > ul {
    position: relative;
    clear: both;
    overflow: hidden;
  }

  .sortMultiple_cell > ul > li {
    padding: 0.2rem 0.5rem;
    background-color: #f5f5f5;
    border-radius: 0.2rem;
    font-size: 0.75rem;
    float: left;
    margin: 0 0.5rem 0.5rem 0;
    border: 1px solid transparent;
  }

  .sortMultiple_cell > ul > .active {
    background-color: #fff7fb;
    border: 1px solid #EB84AB;
    color: #EB84AB;
  }

  .reset_btn {
    padding: 0.3rem 0;
    width: 6.25rem;
    border-radius: 0.5rem;
    background-color: #F5F5F5;
    color: #333333;
  }

  .done_btn {
    padding: 0.3rem 0;
    margin-left: 2rem;
    width: 6.25rem;
    background-color: #EB84AB;
    color: white;
    border-radius: 0.5rem;
  }

  .open_btn {
    width: 1.25rem;
    height: 1.25rem;
  }

  .close_ul {
    height: 0px;
  }

  .cell_title {
    clear: both;
    overflow: hidden;
    width: 21.43rem;
  }

  .cell_title span {
    font-size: 0.875rem;
  }

  .input_view {
    width: 5rem;
    background-color: #f5f5f5;
    border-style: none;
  }

  /*input*/
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #ddd;
    font-size: 0.75rem;
    text-align: center;
  }
  input:-moz-placeholder, textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #ddd;
    font-size: 0.75rem;
    text-align: center;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ddd;
    font-size: 0.75rem;
    text-align: center;
  }
  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #ddd;
    font-size: 0.75rem;
    text-align: center;
  }

  .element::-webkit-scrollbar { width: 0 !important }

  .element { -ms-overflow-style: none; }

  .element { overflow: -moz-scrollbars-none; }

</style>



// WEBPACK FOOTER //
// src/components/page/home/productList.vue